import { render, staticRenderFns } from "./maimairesult.vue?vue&type=template&id=21151d16&scoped=true"
import script from "./maimairesult.vue?vue&type=script&lang=js"
export * from "./maimairesult.vue?vue&type=script&lang=js"
import style0 from "./maimairesult.vue?vue&type=style&index=0&id=21151d16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21151d16",
  null
  
)

export default component.exports